import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TestimonialsLayer from "../components/TestimonialsLayer";

const TestimonialsPage = () => {
  return (
    <MasterLayout>
      <TestimonialsLayer />
    </MasterLayout>
  );
};

export default TestimonialsPage;
